export const MESSAGE_RECEIVED = "message:received"
export const BOOKING_RECEIVED = "booking:received"
export const BOOKING_UPDATED = "booking:updated"
export const LIKE_RECEIVED = "like:received"
export const COMMENT_RECEIVED = "comment:received"
export const FOLLOW_RECEIVED = "follow:received"
export const REVIEW_RECEIVED = "review:received"
export const TEST_RECEIVED = "test:received"
